'use strict';

Object.defineProperty(exports, '__esModule', {
  value: true
});
var _extends = require('@babel/runtime/helpers/extends');
var _slicedToArray = require('@babel/runtime/helpers/slicedToArray');
var framerMotion = require('framer-motion');
var react = require('@chakra-ui/react');
var toast_component = require('./toast.component.js');
var toast_store = require('./toast.store.js');
var toast_utils = require('./toast.utils.js');
var React = require('react');
var reactUtils = require('@chakra-ui/react-utils');
function _interopDefaultLegacy(e) {
  return e && typeof e === 'object' && 'default' in e ? e : {
    'default': e
  };
}
var _extends__default = /*#__PURE__*/_interopDefaultLegacy(_extends);
var _slicedToArray__default = /*#__PURE__*/_interopDefaultLegacy(_slicedToArray);
var React__default = /*#__PURE__*/_interopDefaultLegacy(React);

/**
 * Passes default options down to be used by toast creator function
 */
var _createContext = reactUtils.createContext({
    name: "ToastOptionsContext",
    strict: false
  }),
  _createContext2 = _slicedToArray__default["default"](_createContext, 2),
  ToastOptionProvider = _createContext2[0],
  useToastOptionContext = _createContext2[1];
var ToastProvider = function ToastProvider(props) {
  var state = React.useSyncExternalStore(toast_store.toastStore.subscribe, toast_store.toastStore.getState, toast_store.toastStore.getState);
  var motionVariants = props.motionVariants,
    _props$component = props.component,
    Component = _props$component === void 0 ? toast_component.ToastComponent : _props$component,
    portalProps = props.portalProps;
  var stateKeys = Object.keys(state);
  var toastList = stateKeys.map(function (position) {
    var toasts = state[position];
    return /*#__PURE__*/React__default["default"].createElement("div", {
      role: "region",
      "aria-live": "polite",
      key: position,
      id: "chakra-toast-manager-".concat(position),
      style: toast_utils.getToastListStyle(position)
    }, /*#__PURE__*/React__default["default"].createElement(framerMotion.AnimatePresence, {
      initial: false
    }, toasts.map(function (toast) {
      return /*#__PURE__*/React__default["default"].createElement(Component, _extends__default["default"]({
        key: toast.id,
        motionVariants: motionVariants
      }, toast));
    })));
  });
  return /*#__PURE__*/React__default["default"].createElement(react.Portal, portalProps, toastList);
};
exports.ToastOptionProvider = ToastOptionProvider;
exports.ToastProvider = ToastProvider;
exports.useToastOptionContext = useToastOptionContext;